import React from "react"
import LocationsIntro from "../content/locations_intro"
import AreaList from "../areas/AreaList"
import CollapsibleList from "../areas/CollapsibleList"
import CTA from "../content/cta"

function Locations({ data }) {
  return (
    <>
      <LocationsIntro data={data}/>
      <AreaList areaList={data.allStates} areaName={` `} areaCopy={`CommUSA Has You Covered Coast-to-Coast`}/>
      <CollapsibleList data={data} />
      <CTA />
    </>
  )
}

export default Locations
